/* Footer — mobile accordion columns (Shop / Company). Address and
   Contact stay open and non-collapsible. Desktop columns are always
   open; the buttons only act under 750px. Loaded deferred. */
(function () {
  'use strict';

  var mq = window.matchMedia('(max-width: 749px)');

  document.querySelectorAll('[data-acc]').forEach(function (col) {
    var btn = col.querySelector('[data-acc-btn]');
    if (!btn) return;

    function setOpen(open) {
      col.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    btn.addEventListener('click', function () {
      if (!mq.matches) return;
      setOpen(!col.classList.contains('is-open'));
    });

    function sync() {
      if (mq.matches) {
        setOpen(false);
      } else {
        /* desktop: always open, buttons inert (CSS removes pointer
           events; reflect the state for assistive tech) */
        col.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else mq.addListener(sync);
  });

  /* back to top */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-back-to-top]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  });
})();
